import React from "react";
import dateFormat from "dateformat";
import { Link } from "react-router-dom";
const SingleItem = ({ data, index }) => {
  return (
    <>
      <tr>
        <td data-label="Username">
          <Link to={`/agent/user/details/${data?._id}`}>
            <span className="fw-bold">
              {data?.username}
            </span>
          </Link>
          <br />
        </td>


        <td data-label="Email">
          <Link to={`/agent/user/details/${data?._id}`}>{data?.email}</Link>
        </td>
        <td data-label="Phone">{data?.phone}</td>

        <td data-label="Joined At">
          {dateFormat(data.createdAt, "d-m-yyyy h:MM:ss TT")}
        </td>
        <td data-label="Balance">${data?.balance}</td>
 
        <td data-label="Action">
          <div className="button--group">
            <Link
              to={`/agent/user/details/${data._id}`}
              className="btn btn-sm btn-outline-primary"
            >
              <i className="las la-desktop"></i> Details
            </Link>
          </div>
        </td>
      </tr>
    </>
  );
};

export default SingleItem;
